import staticPermissions from '@/permissions/permissions.json';

import type { PermissionsMap, ResourcePermissions } from '@/permissions/types';

// TODO: When the API endpoint is ready, replace the static import with:
//   const { data } = await apiClient.get<PermissionsMap>(`/permissions/${role}`);
//   return data[role] ?? {};
//
// The returned shape must stay the same: Record<resource, ResourcePermissions>.

export const permissionService = {
  /**
   * Returns the resource-permission map for a given role.
   * Currently served from a local static file; ready to be swapped to an API call.
   */
  getForRole: async (role: string): Promise<Record<string, ResourcePermissions>> => {
    const map = staticPermissions as PermissionsMap;
    return map[role] ?? {};
  },
};
